// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"21dd223b","53":"c21bda63","263":"80069449","467":"c6d56ee3","728":"c6d56ee3"}[chunkId] + ".chunk.css";
};